import Vue from 'vue'
import Vuex from 'vuex'
import app from './modules/app'
// import dict from './modules/dict'
import user from './modules/user'
import tagsView from './modules/tagsView'
import permission from './modules/permission'
import settings from './modules/settings'
import printer from './modules/printer'
import getters from './getters'
import common from "./modules/common";

Vue.use(Vuex)

const store = new Vuex.Store({
    state: {
        inboundData: null, // 存储传递的入库单数据
        editInboundData: null,   // 存储编辑入库单的数据
        copyInboundData: null,   // 存储复制入库单的数据
        copyOrderData: null,   // 存储复制订单的数据
        editOrderData: null,   // 存储编辑订单的数据
        destinationWarehouseMap: {
            '1': 'BR01[巴西一号仓]',
        },
        transferWarehouseMap: {
            '1': 'SZW[深圳中转仓]',
        },
        transferProductMap: {
            '1': 'TCHY[头程海运]',
        },
        receivingTypeMap: {
            '1': '中转代发',
            '2': '自发头程'
        },
        deliveryWarehouseMap: {
            '1': 'SZW[深圳中转仓]',
            '2': 'BR01[巴西一号仓]',
        },
        deliveryMethodMap: {
            '1': '自送',
            '2': '揽收'
        },
        logisticsProductMap: {
            '1': 'TCHY[头程海运]',
        },
    },
    mutations: {
        setInboundData(state, data) {
            state.inboundData = data;
        },
        setEditInboundData(state, data) {
            state.editInboundData = data;
        },
        setCopyInboundData(state, data) {
            state.copyInboundData = data;
        },
        setCopyOrderData(state, data) {
            state.copyOrderData = data;
        },
        setEditOrderData(state, data) {
            state.editOrderData = data;
        },
        clearInboundData(state, type) {
            if (type === 'create') state.inboundData = null;
            else if (type === 'edit') state.editInboundData = null;
            else if (type === 'copy') state.copyInboundData = null;
        },
        clearOrderData(state, type) {
            if (type === 'copy') state.copyOrderData = null;
            else if (type === 'edit') state.editOrderData = null;
        }
    },
    modules: {
        app,
        // dict,
        user,
        tagsView,
        permission,
        settings,
        printer,
        common
    },
    getters
})

store.dispatch('printer/loadSettings')

export default store


// 以下原来的

// import Vue from "vue";
// import Vuex from 'vuex'
//
// Vue.use(Vuex)
//
// const store=new Vuex.Store({
//     state:{
//         currentPathName:''
//     },
//     mutations:{
//         setPath(state){
//             state.currentPathName=localStorage.getItem("currentPathName")
//         }
//     }
// })
// export default store